import React from 'react';
import './Button.css';

const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'large', 
  onClick, 
  disabled = false, 
  loading = false,
  icon: Icon,
  ...props 
}) => {
  const buttonClass = `btn btn-${variant} btn-${size} ${disabled || loading ? 'disabled' : ''}`;

  return (
    <button
      className={buttonClass}
      onClick={onClick}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <div className="btn-spinner">
          <div className="spinner"></div>
        </div>
      ) : (
        <>
          {Icon && (
            <div className="btn-icon">
              <Icon size={20} />
            </div>
          )}
          <span className="btn-text">{children}</span>
        </>
      )}
    </button>
  );
};

// Google Icon Component
export const GoogleIcon = ({ size = 24 }) => (
  <img 
    src="/img/svg/google.svg" 
    alt="Google" 
    width={size} 
    height={size}
  />
);

// Microsoft Icon Component
export const MicrosoftIcon = ({ size = 24 }) => (
  <img 
    src="/img/svg/microsoft.svg" 
    alt="Microsoft" 
    width={size} 
    height={size}
  />
);

export default Button;
